export enum PdfTaskDetailMenuItem {
  LOCATION = 'location',
  LEVEL = 'level',
  TOTAL_TIME = 'totalTime',
  TIME_ESTIMATION = 'timeEstimation',
  PROJECT = 'project',
  FINANCIAL_ESTIMATION = 'financialEstimation',
  STATUS = 'status',
  PRIORITY = 'priority',
  START_DATE = 'startDate',
  END_DATE = 'endDate',
  ADMIN = 'admin',
  USERS = 'users'
}
